import BaseService from "@/boot/BaseService";
class CamaraConfigService extends BaseService {
  constructor() {
    super(null, "/camara-config");
  }
  async index() {
    return await this.get("/");
  }
}

export default new CamaraConfigService();
